<script setup>
import {useUser} from "../../store/user"
import {onMounted, watch} from "vue";
import {useSystem} from "../../store/system";

const systemStore = useSystem()
const userStore = useUser()
//获取用户邀请记录
userStore.referralsLogApi()

const iconBgColors = ['tw-bg-blue-500', 'tw-bg-red-500', 'tw-bg-green-500', 'tw-bg-yellow-500', 'tw-bg-purple-500', 'tw-bg-pink-500',
  'tw-bg-indigo-500', 'tw-bg-teal-500', 'tw-bg-orange-500', 'tw-bg-amber-500', 'tw-bg-lime-500', 'tw-bg-emerald-500', 'tw-bg-cyan-500',
  'tw-bg-sky-500', 'tw-bg-violet-500', 'tw-bg-fuchsia-500', 'tw-bg-rose-500'
]

const getRandomColor = () => {
  let index = Math.floor(Math.random() * iconBgColors.length)
  return iconBgColors[index]
}

</script>

<template>

  <el-row>
    <el-col :span="24">
      <div class="tw-px-4 tw-py-3 tw-flex tw-justify-start tw-items-center card-white-bg-active">
        <el-icon size="25"><InfoFilled /></el-icon>
        <div class="tw-ml-5">
          <div class="tw-font-bold">Referral Rewards</div>
          <div>Share your site with others. You'll get an extra bonus for each purchase they make</div>
        </div>
      </div>
    </el-col>
  </el-row>

  <el-row :gutter="systemStore.getIsMobile? 0 : 20" class="tw-mt-8">
    <el-col :span="24" :md="12">

      <div class="card-bg tw-p-4 tw-rounded-lg tw-group">
        <div class="tw-flex tw-justify-start tw-items-center">
          <div :class="getRandomColor()" class="tw-w-[45px] tw-h-[45px] tw-bg-opacity-50 group-hover:tw-bg-opacity-100 tw-flex tw-justify-center tw-items-center tw-rounded-md tw-shrink-0">
            <font-awesome-icon class="text-[25px]" :icon="['fas', 'wallet']" />
          </div>
          <div class="tw-ml-3 tw-text-[16px] tw-font-bold">Total Referrals</div>
        </div>
        <div class="tw-mt-3 tw-text-[20px]">{{userStore.getReferralsStatics.total_referrals}}</div>
      </div>

    </el-col>
    <el-col :span="24" :md="12">

      <div class="card-bg tw-p-4 tw-rounded-lg tw-group">
        <div class="tw-flex tw-justify-start tw-items-center">
          <div :class="getRandomColor()" class="tw-w-[45px] tw-h-[45px] tw-bg-opacity-50 group-hover:tw-bg-opacity-100 tw-flex tw-justify-center tw-items-center tw-rounded-md tw-shrink-0">
            <font-awesome-icon class="text-[25px]" :icon="['fas', 'wallet']" />
          </div>
          <div class="tw-ml-3 tw-text-[16px] tw-font-bold">Total Earnings</div>
        </div>
        <div class="tw-mt-3 tw-text-[20px]"><span class="tw-mr-1">$</span>{{userStore.getReferralsStatics.total_rebate}}</div>
      </div>

    </el-col>
  </el-row>

  <el-row>
    <el-col :span="24">
      <div class="tw-text-white tw-mt-3">
        <div class="tw-py-3">Affiliate Link</div>
        <div class="tw-flex tw-justify-between tw-items-center link-bg tw-p-6 tw-rounded-lg">
          <div>{{userStore.getInviteLink}}</div>
          <!--          使用watch只监听一次全局挂载 在header中实现的 copyBtn 该功能-->
          <el-button class="copyBtn">Copy</el-button>
        </div>
      </div>
    </el-col>
  </el-row>

  <el-row>
    <el-col :span="24">
      <div class="card-bg tw-mt-8">
        <div class="tw-p-4 tw-bottom-line tw-font-bold tw-text-[18px]">Referral Log</div>
        <div class="tw-p-4">
          <el-table
              :data="userStore.getReferralsList"
              class="tw-w-full"
          >
            <el-table-column prop="email" label="Email"/>
            <el-table-column prop="jointime" label="Join Date">
              <template #default="{row, column, $index}">
                <div>{{systemStore.formatDate(row.jointime)}}</div>
              </template>
            </el-table-column>
            <el-table-column prop="prevtime" label="Prev Date">
              <template #default="{row, column, $index}">
                <div>{{systemStore.formatDate(row.prevtime)}}</div>
              </template>
            </el-table-column>
            <template #empty>
              <el-empty :image-size="120"></el-empty>
            </template>
          </el-table>
        </div>
      </div>
    </el-col>
    <el-col :span="24" class="mt-4">
      <el-pagination
          background layout="prev, pager, next"
          :page-size="parseInt(userStore.getReferralsPage.limit)"
          :total="parseInt(userStore.getReferralsPage.total)"
          @change="userStore.referralsChange" />
    </el-col>
  </el-row>
</template>

<style lang="scss">
.el-form-item__label{
  color: $p-text-color !important;
}

.el-table {
  background-color: unset !important;
  color: #FFFFFF;
  border-color: $p-border-color !important;

  // 每行tr的底部线条
  td.el-table__cell, .is-leaf{
    border-bottom: 2px solid $p-border-color !important;
  }

  //解决最后一排边框线
  .el-table__inner-wrapper:before{
    background-color: unset !important;
  }

  .el-table__header-wrapper {
    tr {
      // 表头背景色
      background-color: unset;

      th {
        color: $p-text-color;
        background-color: rgba(0, 0, 0, 0);
      }
    }

  }

  .el-table__body-wrapper {
    tr {
      // 表格内容背景色
      background-color: unset;
      color: $p-text-color;

      &:hover>td {
        //修改(hover)悬浮背景色
        background-color: $p-table-row-active-color !important;
      }
    }
  }
}
</style>
